module.exports = __webpack_public_path__ + "KaTeX_Caligraphic-Regular.828cff46.woff";